// @flow
import { ACTIONS } from './constants';

export default function reactionsLookup(state: any = {}, action: any = {}) {
    if (action.type === ACTIONS.LOAD_REACTIONS) {
        return action.reactions.reduce(
            (accumulator: any, currentValue: any) => {
                return {
                    ...accumulator,
                    [currentValue.reactionId]: currentValue
                };
            },
            {}
        );
    }

    return state;
}
